// eslint-disable-next-line import/prefer-default-export

export const checkRes = param => {
  if (param === 200 || param === 201 || param === 212) {
    return true
  }
  return false
}

